(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4495],{

/***/ 69661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Avatar_Avatar; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/DefaultPropsProvider/DefaultPropsProvider.js + 1 modules
var DefaultPropsProvider = __webpack_require__(85845);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(82066);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/internal/svg-icons/Person.js
'use client';




/**
 * @ignore - internal component.
 */

/* harmony default export */ var Person = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), 'Person'));
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Avatar/avatarClasses.js


function getAvatarUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiAvatar', slot);
}
const avatarClasses = (0,generateUtilityClasses/* default */.Z)('MuiAvatar', ['root', 'colorDefault', 'circular', 'rounded', 'square', 'img', 'fallback']);
/* harmony default export */ var Avatar_avatarClasses = ((/* unused pure expression or super */ null && (avatarClasses)));
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useSlot.js
var useSlot = __webpack_require__(80560);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Avatar/Avatar.js
'use client';



const _excluded = ["alt", "children", "className", "component", "slots", "slotProps", "imgProps", "sizes", "src", "srcSet", "variant"];










const useUtilityClasses = ownerState => {
  const {
    classes,
    variant,
    colorDefault
  } = ownerState;
  const slots = {
    root: ['root', variant, colorDefault && 'colorDefault'],
    img: ['img'],
    fallback: ['fallback']
  };
  return (0,composeClasses/* default */.Z)(slots, getAvatarUtilityClass, classes);
};
const AvatarRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiAvatar',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], ownerState.colorDefault && styles.colorDefault];
  }
})(({
  theme
}) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: 40,
  height: 40,
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.pxToRem(20),
  lineHeight: 1,
  borderRadius: '50%',
  overflow: 'hidden',
  userSelect: 'none',
  variants: [{
    props: {
      variant: 'rounded'
    },
    style: {
      borderRadius: (theme.vars || theme).shape.borderRadius
    }
  }, {
    props: {
      variant: 'square'
    },
    style: {
      borderRadius: 0
    }
  }, {
    props: {
      colorDefault: true
    },
    style: (0,esm_extends/* default */.Z)({
      color: (theme.vars || theme).palette.background.default
    }, theme.vars ? {
      backgroundColor: theme.vars.palette.Avatar.defaultBg
    } : (0,esm_extends/* default */.Z)({
      backgroundColor: theme.palette.grey[400]
    }, theme.applyStyles('dark', {
      backgroundColor: theme.palette.grey[600]
    })))
  }]
}));
const AvatarImg = (0,styled/* default */.ZP)('img', {
  name: 'MuiAvatar',
  slot: 'Img',
  overridesResolver: (props, styles) => styles.img
})({
  width: '100%',
  height: '100%',
  textAlign: 'center',
  // Handle non-square image. The property isn't supported by IE11.
  objectFit: 'cover',
  // Hide alt text.
  color: 'transparent',
  // Hide the image broken icon, only works on Chrome.
  textIndent: 10000
});
const AvatarFallback = (0,styled/* default */.ZP)(Person, {
  name: 'MuiAvatar',
  slot: 'Fallback',
  overridesResolver: (props, styles) => styles.fallback
})({
  width: '75%',
  height: '75%'
});
function useLoaded({
  crossOrigin,
  referrerPolicy,
  src,
  srcSet
}) {
  const [loaded, setLoaded] = react.useState(false);
  react.useEffect(() => {
    if (!src && !srcSet) {
      return undefined;
    }
    setLoaded(false);
    let active = true;
    const image = new Image();
    image.onload = () => {
      if (!active) {
        return;
      }
      setLoaded('loaded');
    };
    image.onerror = () => {
      if (!active) {
        return;
      }
      setLoaded('error');
    };
    image.crossOrigin = crossOrigin;
    image.referrerPolicy = referrerPolicy;
    image.src = src;
    if (srcSet) {
      image.srcset = srcSet;
    }
    return () => {
      active = false;
    };
  }, [crossOrigin, referrerPolicy, src, srcSet]);
  return loaded;
}
const Avatar = /*#__PURE__*/react.forwardRef(function Avatar(inProps, ref) {
  const props = (0,DefaultPropsProvider/* useDefaultProps */.i)({
    props: inProps,
    name: 'MuiAvatar'
  });
  const {
      alt,
      children: childrenProp,
      className,
      component = 'div',
      slots = {},
      slotProps = {},
      imgProps,
      sizes,
      src,
      srcSet,
      variant = 'circular'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  let children = null;

  // Use a hook instead of onError on the img element to support server-side rendering.
  const loaded = useLoaded((0,esm_extends/* default */.Z)({}, imgProps, {
    src,
    srcSet
  }));
  const hasImg = src || srcSet;
  const hasImgNotFailing = hasImg && loaded !== 'error';
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    colorDefault: !hasImgNotFailing,
    component,
    variant
  });
  const classes = useUtilityClasses(ownerState);
  const [ImgSlot, imgSlotProps] = (0,useSlot/* default */.Z)('img', {
    className: classes.img,
    elementType: AvatarImg,
    externalForwardedProps: {
      slots,
      slotProps: {
        img: (0,esm_extends/* default */.Z)({}, imgProps, slotProps.img)
      }
    },
    additionalProps: {
      alt,
      src,
      srcSet,
      sizes
    },
    ownerState
  });
  if (hasImgNotFailing) {
    children = /*#__PURE__*/(0,jsx_runtime.jsx)(ImgSlot, (0,esm_extends/* default */.Z)({}, imgSlotProps));
    // We only render valid children, non valid children are rendered with a fallback
    // We consider that invalid children are all falsy values, except 0, which is valid.
  } else if (!!childrenProp || childrenProp === 0) {
    children = childrenProp;
  } else if (hasImg && alt) {
    children = alt[0];
  } else {
    children = /*#__PURE__*/(0,jsx_runtime.jsx)(AvatarFallback, {
      ownerState: ownerState,
      className: classes.fallback
    });
  }
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AvatarRoot, (0,esm_extends/* default */.Z)({
    as: component,
    ownerState: ownerState,
    className: (0,clsx/* default */.Z)(classes.root, className),
    ref: ref
  }, other, {
    children: children
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Avatar_Avatar = (Avatar);

/***/ }),

/***/ 80560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useSlot; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63366);
/* harmony import */ var _mui_utils_useForkRef__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33703);
/* harmony import */ var _mui_utils_appendOwnerState__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86542);
/* harmony import */ var _mui_utils_resolveComponentProps__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65610);
/* harmony import */ var _mui_utils_mergeSlotProps__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55120);
'use client';



const _excluded = ["className", "elementType", "ownerState", "externalForwardedProps", "getSlotOwnerState", "internalForwardedProps"],
  _excluded2 = ["component", "slots", "slotProps"],
  _excluded3 = ["component"];




/**
 * An internal function to create a Material UI slot.
 *
 * This is an advanced version of Base UI `useSlotProps` because Material UI allows leaf component to be customized via `component` prop
 * while Base UI does not need to support leaf component customization.
 *
 * @param {string} name: name of the slot
 * @param {object} parameters
 * @returns {[Slot, slotProps]} The slot's React component and the slot's props
 *
 * Note: the returned slot's props
 * - will never contain `component` prop.
 * - might contain `as` prop.
 */
function useSlot(
/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */
name, parameters) {
  const {
      className,
      elementType: initialElementType,
      ownerState,
      externalForwardedProps,
      getSlotOwnerState,
      internalForwardedProps
    } = parameters,
    useSlotPropsParams = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(parameters, _excluded);
  const {
      component: rootComponent,
      slots = {
        [name]: undefined
      },
      slotProps = {
        [name]: undefined
      }
    } = externalForwardedProps,
    other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(externalForwardedProps, _excluded2);
  const elementType = slots[name] || initialElementType;

  // `slotProps[name]` can be a callback that receives the component's ownerState.
  // `resolvedComponentsProps` is always a plain object.
  const resolvedComponentsProps = (0,_mui_utils_resolveComponentProps__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(slotProps[name], ownerState);
  const _mergeSlotProps = (0,_mui_utils_mergeSlotProps__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
      className
    }, useSlotPropsParams, {
      externalForwardedProps: name === 'root' ? other : undefined,
      externalSlotProps: resolvedComponentsProps
    })),
    {
      props: {
        component: slotComponent
      },
      internalRef
    } = _mergeSlotProps,
    mergedProps = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mergeSlotProps.props, _excluded3);
  const ref = (0,_mui_utils_useForkRef__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, parameters.ref);
  const slotOwnerState = getSlotOwnerState ? getSlotOwnerState(mergedProps) : {};
  const finalOwnerState = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, ownerState, slotOwnerState);
  const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
  const props = (0,_mui_utils_appendOwnerState__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(elementType, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, name === 'root' && !rootComponent && !slots[name] && internalForwardedProps, name !== 'root' && !slots[name] && internalForwardedProps, mergedProps, LeafComponent && {
    as: LeafComponent
  }, {
    ref
  }), finalOwnerState);
  Object.keys(slotOwnerState).forEach(propName => {
    delete props[propName];
  });
  return [elementType, props];
}

/***/ }),

/***/ 61730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMediaQuery; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_utils_useEnhancedEffect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73546);
/* harmony import */ var _useThemeProps__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20539);
/* harmony import */ var _useThemeWithoutDefault__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34168);
'use client';






/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */

/**
 * @deprecated Not used internally. Use `MediaQueryList` from lib.dom.d.ts instead.
 */

/**
 * @deprecated Not used internally. Use `(event: MediaQueryListEvent) => void` instead.
 */

function useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
  const [match, setMatch] = react__WEBPACK_IMPORTED_MODULE_0__.useState(() => {
    if (noSsr && matchMedia) {
      return matchMedia(query).matches;
    }
    if (ssrMatchMedia) {
      return ssrMatchMedia(query).matches;
    }

    // Once the component is mounted, we rely on the
    // event listeners to return the correct matches value.
    return defaultMatches;
  });
  (0,_mui_utils_useEnhancedEffect__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(() => {
    let active = true;
    if (!matchMedia) {
      return undefined;
    }
    const queryList = matchMedia(query);
    const updateMatch = () => {
      // Workaround Safari wrong implementation of matchMedia
      // TODO can we remove it?
      // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
      if (active) {
        setMatch(queryList.matches);
      }
    };
    updateMatch();
    // TODO: Use `addEventListener` once support for Safari < 14 is dropped
    queryList.addListener(updateMatch);
    return () => {
      active = false;
      queryList.removeListener(updateMatch);
    };
  }, [query, matchMedia]);
  return match;
}

// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const maybeReactUseSyncExternalStore = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useSyncExternalStore' + ''];
function useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
  const getDefaultSnapshot = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(() => defaultMatches, [defaultMatches]);
  const getServerSnapshot = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    if (noSsr && matchMedia) {
      return () => matchMedia(query).matches;
    }
    if (ssrMatchMedia !== null) {
      const {
        matches
      } = ssrMatchMedia(query);
      return () => matches;
    }
    return getDefaultSnapshot;
  }, [getDefaultSnapshot, query, ssrMatchMedia, noSsr, matchMedia]);
  const [getSnapshot, subscribe] = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    if (matchMedia === null) {
      return [getDefaultSnapshot, () => () => {}];
    }
    const mediaQueryList = matchMedia(query);
    return [() => mediaQueryList.matches, notify => {
      // TODO: Use `addEventListener` once support for Safari < 14 is dropped
      mediaQueryList.addListener(notify);
      return () => {
        mediaQueryList.removeListener(notify);
      };
    }];
  }, [getDefaultSnapshot, matchMedia, query]);
  const match = maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  return match;
}
function useMediaQuery(queryInput, options = {}) {
  const theme = (0,_useThemeWithoutDefault__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  // Wait for jsdom to support the match media feature.
  // All the browsers MUI support have this built-in.
  // This defensive check is here for simplicity.
  // Most of the time, the match media logic isn't central to people tests.
  const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
  const {
    defaultMatches = false,
    matchMedia = supportMatchMedia ? window.matchMedia : null,
    ssrMatchMedia = null,
    noSsr = false
  } = (0,_useThemeProps__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    name: 'MuiUseMediaQuery',
    props: options,
    theme
  });
  if (false) {}
  let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
  query = query.replace(/^@media( ?)/m, '');

  // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
  const useMediaQueryImplementation = maybeReactUseSyncExternalStore !== undefined ? useMediaQueryNew : useMediaQueryOld;
  const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
  if (false) {}
  return match;
}

/***/ }),

/***/ 20539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getThemeProps; }
/* harmony export */ });
/* harmony import */ var _mui_utils_resolveProps__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35971);

function getThemeProps(params) {
  const {
    theme,
    name,
    props
  } = params;
  if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) {
    return props;
  }
  return (0,_mui_utils_resolveProps__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(theme.components[name].defaultProps, props);
}

/***/ }),

/***/ 62804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ox": function() { return /* binding */ getCountries; },
  "IS": function() { return /* binding */ loginCallback; },
  "QO": function() { return /* binding */ userChangePassword; },
  "nu": function() { return /* binding */ userConfirmEmail; },
  "X1": function() { return /* binding */ userForgotPassword; },
  "cq": function() { return /* binding */ userGetProfile; },
  "Kv": function() { return /* binding */ userLogout; },
  "lf": function() { return /* binding */ userResendConfirmEmail; },
  "Fw": function() { return /* binding */ userRestorePassword; },
  "ii": function() { return /* binding */ userSignIn; },
  "EQ": function() { return /* binding */ userSignUp; },
  "lP": function() { return /* binding */ userUpdateProfile; }
});

// EXTERNAL MODULE: ./api/base-services.request.ts + 1 modules
var base_services_request = __webpack_require__(11882);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
;// CONCATENATED MODULE: ./shared/models/endpoits/clients/clients.endpoints.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var ClientsStatic;

(function (ClientsStatic) {
  ClientsStatic["register"] = "/v2/clients/sign-up";
  ClientsStatic["login"] = "/v2/clients/login";
  ClientsStatic["logout"] = "/v2/clients/logout";
  ClientsStatic["forgotPassword"] = "/v2/clients/send-forgot-pasword";
  ClientsStatic["changePassword"] = "/v2/clients/change-password";
  ClientsStatic["confirmEmail"] = "/v2/clients/confirm-email";
  ClientsStatic["resendConfirmEmail"] = "/v2/clients/resend-confirm-email";
  ClientsStatic["profile"] = "/v2/clients";
  ClientsStatic["updateProfile"] = "/v2/clients/edit?_method=PUT";
  ClientsStatic["countries"] = "/v2/clients/countries";
})(ClientsStatic || (ClientsStatic = {}));

var ClientsDynamic = {
  /**
   * @member {string}
   * @method POST
   * @version 2.0
   * @description Send new password.
   */
  resetPassword: function resetPassword(userId) {
    return "/v2/clients/reset-password/" + userId;
  },

  /**
   * @member {string}
   * @method GET
   * @version 2.0
   * @description Send search params to callback for OAuth.
   */
  loginCallback: function loginCallback(provider) {
    return "/v2/clients/login/".concat(provider, "/callback");
  }
};
var ClientsEndpoints = _objectSpread(_objectSpread({}, ClientsDynamic), ClientsStatic);
;// CONCATENATED MODULE: ./api/clients/clients.request.ts


function userSignUp(body) {
  return (0,base_services_request/* postRequest */.j0)(ClientsEndpoints.register, body).then(function (res) {
    return res === null || res === void 0 ? void 0 : res.data;
  });
}
function userSignIn(body) {
  return (0,base_services_request/* postRequest */.j0)(ClientsEndpoints.login, body).then(function (_ref) {
    var data = _ref.data;
    return data.data;
  });
}
function userLogout() {
  return (0,base_services_request/* postRequest */.j0)(ClientsEndpoints.logout, null).then(function (res) {
    return res === null || res === void 0 ? void 0 : res.data;
  });
}
function userForgotPassword(body) {
  return (0,base_services_request/* postRequest */.j0)(ClientsEndpoints.forgotPassword, body).then(function (res) {
    return res === null || res === void 0 ? void 0 : res.data;
  });
}
function userRestorePassword(clientId, searchParams, body) {
  return (0,base_services_request/* postRequest */.j0)(ClientsEndpoints.resetPassword(clientId) + searchParams, body).then(function (res) {
    return res === null || res === void 0 ? void 0 : res.data;
  });
}
function userChangePassword(body) {
  return (0,base_services_request/* patchResquest */.Ft)(ClientsEndpoints.changePassword, body).then(function (_ref2) {
    var data = _ref2.data;
    return data;
  });
}
function userConfirmEmail(body) {
  return (0,base_services_request/* postRequest */.j0)(ClientsEndpoints.confirmEmail, body).then(function (res) {
    return res === null || res === void 0 ? void 0 : res.data;
  });
}
function userResendConfirmEmail(body) {
  return (0,base_services_request/* postRequest */.j0)(ClientsEndpoints.resendConfirmEmail, body).then(function (res) {
    return res === null || res === void 0 ? void 0 : res.data;
  });
}
function loginCallback(provider, searchParams) {
  return (0,base_services_request/* getRequest */.A_)(ClientsEndpoints.loginCallback(provider) + searchParams).then(function (res) {
    return res === null || res === void 0 ? void 0 : res.data.data;
  });
}
function userUpdateProfile(body) {
  var useMultipartFormData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return (0,base_services_request/* postRequest */.j0)(ClientsEndpoints.updateProfile, body, useMultipartFormData).then(function (_ref3) {
    var data = _ref3.data;
    return data.data;
  });
}
function userGetProfile() {
  return (0,base_services_request/* getRequest */.A_)(ClientsEndpoints.profile).then(function (_ref4) {
    var data = _ref4.data;
    return data.data;
  });
}
function getCountries() {
  return (0,base_services_request/* getRequest */.A_)(ClientsEndpoints.countries).then(function (_ref5) {
    var data = _ref5.data;
    return data.data;
  });
}

/***/ }),

/***/ 44231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ useWidth; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90116);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2734);
/* harmony import */ var _mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61730);



function useWidth() {
  var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();

  var keys = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(theme.breakpoints.keys).reverse();

  return keys.reduce(function (output, key) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var matches = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(theme.breakpoints.up(key));
    return !output && matches ? key : output;
  }, null) || "xs";
}

/***/ }),

/***/ 12948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13179);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var custom_hooks_redux_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99109);
/* harmony import */ var shared_models_const_pages_path__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1283);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(69661);
/* harmony import */ var _components_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66621);
/* harmony import */ var store_feature_auth_auth_slice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(42550);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _components_profile_picture__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(68769);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(36492);
/* harmony import */ var api_clients_clients_request__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(62804);
/* harmony import */ var _components_custom_carrusel__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(20518);
/* harmony import */ var _components_skeletons_property_collector_card_skeleton__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(58254);
/* harmony import */ var api_clients_favorites_favorites_request__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(16366);
/* harmony import */ var custom_hooks_useGetPersintParamas_hook__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(53541);
/* harmony import */ var custom_hooks_useWindowsSize_hook__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(51860);
/* harmony import */ var _components_property_card__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(39470);
/* harmony import */ var _emotion_css__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(18872);
/* harmony import */ var _mui_icons_material_HeartBroken__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(73922);
/* harmony import */ var shared_layouts_user_settings__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(74232);
/* harmony import */ var _components_loading_bubbles__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(47364);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(70917);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


























function ProfilePage(props) {
  var _userData$social_netw;

  var titleT = (0,next_intl__WEBPACK_IMPORTED_MODULE_20__.useTranslations)("title-pages");
  var t = (0,next_intl__WEBPACK_IMPORTED_MODULE_20__.useTranslations)("ProfilePage");
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();

  var _user = (0,custom_hooks_redux_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useAppSelector */ .C)(function (state) {
    return state.Auth.user;
  });

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null),
      userData = _useState[0],
      setUserData = _useState[1];

  var dispatch = (0,custom_hooks_redux_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useAppDispatch */ .T)();
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    setUserData(_user);
    if (!_user) router.push(shared_models_const_pages_path__WEBPACK_IMPORTED_MODULE_5__/* .CPagesPath.es.signin */ .K.es.signin);
  }, [_user, router]);
  (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_21__/* .useQuery */ .a)(["user/profile"], api_clients_clients_request__WEBPACK_IMPORTED_MODULE_10__/* .userGetProfile */ .cq, {
    staleTime: Infinity,
    cacheTime: Infinity,
    onSuccess: function onSuccess(data) {
      if (data) setUserCb(data);
    }
  });
  var size = (0,custom_hooks_useWindowsSize_hook__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)();
  var width = size === null || size === void 0 ? void 0 : size.width;
  var ref = (0,custom_hooks_useGetPersintParamas_hook__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)();

  var _useQuery = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_21__/* .useQuery */ .a)(["favorites"], function () {
    return (0,api_clients_favorites_favorites_request__WEBPACK_IMPORTED_MODULE_13__/* .getFavorites */ ._l)({
      page: 1
    });
  }, {
    cacheTime: Infinity
  }),
      isLoading = _useQuery.isLoading,
      favorites = _useQuery.data;

  var setUserCb = function setUserCb(data) {
    dispatch((0,store_feature_auth_auth_slice__WEBPACK_IMPORTED_MODULE_7__/* .setUser */ .av)(data));
    setUserData(data);
  };

  if (!userData) return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)(_components_loading_bubbles__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
    center: true,
    message: "Cargando"
  });
  var socialNetworks = userData.social_networks;
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)("title", null, titleT("profile"))), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)(Main, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)(Header, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)("h1", null, t("title"))), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)(UserDataContainer, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .ZP, {
    container: true,
    className: dataBanner
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .ZP, {
    item: true
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)(_components_profile_picture__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
    src: userData.profile_picture,
    size: 225
  })), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .ZP, {
    item: true
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)(UserData, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
    src: "/images/v2/logos/7.png",
    alt: "Logo Re/max",
    sx: {
      width: 150,
      height: "auto",
      objectFit: "contain",
      margin: "5px 0"
    },
    variant: "square"
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)("hr", null), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)("h2", null, userData.full_name), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)(UserProfileDataFields, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)(UserProfileDataField, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)("strong", null, "Whatsapp: "), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)("span", null, (_userData$social_netw = userData.social_networks) === null || _userData$social_netw === void 0 ? void 0 : _userData$social_netw.whatsapp)), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)(UserProfileDataField, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)("strong", null, t("labels.user-data.phone"), ": "), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)("span", null, userData.phone)), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)(UserProfileDataField, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)("strong", null, t("labels.user-data.email"), ": "), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)("span", null, userData.email))))), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .ZP, {
    item: true
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)(ButtonsList, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
    href: shared_models_const_pages_path__WEBPACK_IMPORTED_MODULE_5__/* .CPagesPath.es.profileCambiarClave */ .K.es.profileCambiarClave,
    passHref: true
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)(_components_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    thin_button: true,
    fullWidth: true,
    className: noWrap,
    sx: {
      maxWidth: 200,
      mx: "auto",
      mb: 1
    },
    bg: "--color-brand-grey-secondary"
  }, t("links.change-password"))), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
    href: shared_models_const_pages_path__WEBPACK_IMPORTED_MODULE_5__/* .CPagesPath.es.profileEditar */ .K.es.profileEditar,
    passHref: true
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)(_components_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    thin_button: true,
    fullWidth: true,
    sx: {
      maxWidth: 200,
      mx: "auto",
      mb: 1
    },
    bg: "--color-brand-blue-main"
  }, t("links.edit-profile"))), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)(_components_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    thin_button: true,
    fullWidth: true,
    sx: {
      maxWidth: 200,
      mx: "auto",
      mb: 1
    },
    onClick: function onClick() {
      return dispatch((0,store_feature_auth_auth_slice__WEBPACK_IMPORTED_MODULE_7__/* .logout */ .kS)());
    }
  }, t("buttons.logout"))), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)("section", {
    className: "social-networks"
  }, socialNetworks && Object.keys(socialNetworks).map(function (key, i) {
    return key === "whatsapp" ? null : socialNetworks[key] && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)("a", {
      href: socialNetworks[key],
      key: i,
      target: "_blank",
      rel: "noreferrer"
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)("img", {
      src: "/icons/".concat(key, "_icon_gray.svg"),
      alt: key + " icon"
    }));
  }))))), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)(FavoritesSection, {
    className: favorites && !favorites.data.length ? "no-favorites" : ""
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)(SubHeader, null, t("sub_headers.favorites")), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)(_components_custom_carrusel__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
    enablePlaceholder: true,
    placeholderItem: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)(_components_skeletons_property_collector_card_skeleton__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, null),
    numberOfPlaceholderItems: 4,
    forcePlaceHolder: !favorites && isLoading
  }, favorites && favorites.data.map(function (property, i) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
      key: i,
      href: shared_models_const_pages_path__WEBPACK_IMPORTED_MODULE_5__/* .CPagesPath.es.property_detail */ .K.es.property_detail(property) + ref,
      passHref: true
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)(CardWrapper, {
      key: i,
      target: width > 991 ? "_blank" : ""
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)(_components_property_card__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, property)));
  })), favorites && favorites.meta.total > 0 ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)("p", {
    className: linkToFavs
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
    href: shared_models_const_pages_path__WEBPACK_IMPORTED_MODULE_5__/* .CPagesPath.es.profileFavorites */ .K.es.profileFavorites
  }, t("links.view-all-favorites"))) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)(NoFavorites, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)("span", null, t("labels.no-favorites"), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)("br", null), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .jsx */ .tZ)(_mui_icons_material_HeartBroken__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, null))))));
}

ProfilePage.Layout = shared_layouts_user_settings__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z;
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (ProfilePage); //#region Styles

var ButtonsList = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("section",  true ? {
  target: "e10iw0cg10"
} : 0)( true ? {
  name: "10gyp9a",
  styles: "display:flex;flex-direction:column;margin-top:20px"
} : 0);

var noWrap = /*#__PURE__*/(0,_emotion_css__WEBPACK_IMPORTED_MODULE_17__/* .css */ .iv)( true ? {
  name: "1bmnxg7",
  styles: "white-space:nowrap"
} : 0);

var NoFavorites = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e10iw0cg9"
} : 0)( true ? {
  name: "11kx25k",
  styles: "display:grid;place-content:center;margin-top:30px;text-align:center;span{color:var(--color-brand-blue-main);font-weight:bold;}"
} : 0);

var Main = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e10iw0cg8"
} : 0)( true ? {
  name: "1kjwsjj",
  styles: "display:grid;grid-template-rows:90px minmax(338px, auto) 1fr;grid-row-gap:20px;min-height:var(--main-height)"
} : 0);

var Header = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("section",  true ? {
  target: "e10iw0cg7"
} : 0)( true ? {
  name: "yj1uwa",
  styles: "display:grid;place-content:center;margin-top:20px;h1{color:var(--color-brand-blue-main);text-transform:uppercase;}"
} : 0);

var UserDataContainer = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("section",  true ? {
  target: "e10iw0cg6"
} : 0)( true ? {
  name: "nswd3k",
  styles: "display:grid;background-color:white;justify-items:center;width:100%;.buttons-list{margin-top:20px;&>.MuiButtonBase-root{margin-bottom:5px;}}.social-networks{margin-top:10px;display:grid;grid-template-columns:repeat(auto-fit, 40px);justify-content:center;grid-gap:10px;img{width:30px;height:30px;}}"
} : 0);

var dataBanner = /*#__PURE__*/(0,_emotion_css__WEBPACK_IMPORTED_MODULE_17__/* .css */ .iv)( true ? {
  name: "18udyfs",
  styles: "display:grid;max-width:800px;margin:auto;grid-template-columns:minmax(0, 225px) 2fr 1fr;grid-gap:10px;padding:0 20px;align-items:center;@media (max-width: 599px){grid-template-columns:1fr;justify-items:center;margin:30px 0;}"
} : 0);

var UserData = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e10iw0cg5"
} : 0)( true ? {
  name: "1hzpivo",
  styles: "padding-top:10px;margin-left:10px;hr{max-width:160px;}h2{margin:16px 0 20px;font-size:20px;text-align:left;color:var(--color-brand-blue-main);}"
} : 0);

var UserProfileDataFields = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e10iw0cg4"
} : 0)( true ? {
  name: "toxi42",
  styles: "&>p{margin-bottom:10px;}"
} : 0);

var UserProfileDataField = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("p",  true ? {
  target: "e10iw0cg3"
} : 0)( true ? {
  name: "1qur3w0",
  styles: "font-weight:bold;font-size:17px;span{color:var(--color-brand-grey-secondary);}"
} : 0);

var FavoritesSection = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("section",  true ? {
  target: "e10iw0cg2"
} : 0)( true ? {
  name: "1vzp4ja",
  styles: "margin:auto;margin-top:20px;max-width:var(--list-max-width);width:calc(100vw - 270px);&.no-favorites{display:grid;place-content:center;grid-template-columns:1fr;grid-template-rows:40px 0px 1fr;}@media (max-width: 899px){width:calc(100vw - 40px);}"
} : 0);

var SubHeader = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("h3",  true ? {
  target: "e10iw0cg1"
} : 0)( true ? {
  name: "1fgxbez",
  styles: "color:var(--color-brand-blue-main);text-align:center;margin-bottom:20px"
} : 0);

var CardWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("a",  true ? {
  target: "e10iw0cg0"
} : 0)( true ? {
  name: "1x1uwkl",
  styles: "display:flex;justify-content:center;max-width:100%;margin:5px"
} : 0);

var linkToFavs = /*#__PURE__*/(0,_emotion_css__WEBPACK_IMPORTED_MODULE_17__/* .css */ .iv)( true ? {
  name: "o4btxf",
  styles: "text-align:center;margin:40px;font-weight:600;a{color:var(--color-brand-grey-secondary);&:hover{text-decoration:underline;}}"
} : 0); //#endregion

/***/ }),

/***/ 66621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36864);
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25662);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70917);
/* harmony import */ var _mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98456);


var _excluded = ["loadingMessage", "thin_button"];






var Button = function Button(_ref, ref) {
  var _props$bg, _props$fs, _ref2;

  var loadingMessage = _ref.loadingMessage,
      thin_button = _ref.thin_button,
      props = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, _excluded);

  var backgroundColor = (props === null || props === void 0 ? void 0 : props.variant) != "text" ? "var(".concat((_props$bg = props === null || props === void 0 ? void 0 : props.bg) !== null && _props$bg !== void 0 ? _props$bg : "--color-brand-red-main", ")") : "transparent";
  var styles = {
    root:
    /*#__PURE__*/

    /*#__PURE__*/
    (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)({
      boxShadow: "none",
      transition: "0.5s",
      fontFamily: "var(--font-family)",
      fontWeight: 700,
      fontSize: (_props$fs = props.fs) !== null && _props$fs !== void 0 ? _props$fs : 12,
      padding: thin_button ? "0.5rem 2rem" : "10px 35px 10px 35px",
      // @ts-ignore
      color: (_ref2 = "var(".concat(props.colortext, ")")) !== null && _ref2 !== void 0 ? _ref2 : "var(--color-brand-bg-secondary)",
      borderRadius: 28,
      textAlign: "center",
      backgroundColor: backgroundColor,
      ":hover": {
        backgroundColor: backgroundColor,
        opacity: 0.9,
        scale: "1.05",
        transition: "1s"
      }
    },  true ? "" : 0,  true ? "" : 0,  true ? "" : 0,  true ? "" : 0)
  };
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    target: props === null || props === void 0 ? void 0 : props.target,
    variant: "contained",
    css: styles.root
  }, props), loadingMessage !== null && loadingMessage !== void 0 ? loadingMessage : props.children, loadingMessage && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    style: {
      width: 20,
      height: 20,
      color: "red",
      marginLeft: 10
    }
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(Button));

/***/ }),

/***/ 20518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71383);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_icons_material_ArrowBackIosNewRounded__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76083);
/* harmony import */ var _mui_icons_material_ArrowForwardIosRounded__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47111);
/* harmony import */ var custom_hooks_use_width_hook__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44231);
/* harmony import */ var _slick_slider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84256);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90948);


var _templateObject;










function CustomCarrusel(props) {
  var _props$colorArrow, _props$colorArrow2, _props$children, _props$numberOfPlaceh;

  var width = (0,custom_hooks_use_width_hook__WEBPACK_IMPORTED_MODULE_2__/* .useWidth */ .z)();
  var rows = {
    xs: 1,
    sm: 1,
    md: 2,
    lg: 3,
    xl: 4
  };
  var arrowsLeft =
  /*#__PURE__*/

  /*#__PURE__*/
  (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("color:", (_props$colorArrow = props.colorArrow) !== null && _props$colorArrow !== void 0 ? _props$colorArrow : "var(--color-brand-blue-main)", "!important;font-size:clamp(1.5rem, 2.5vw, 2.6rem);padding:2px;position:absolute;z-index:500;left:", width === "xs" || width === "sm" ? "-25px" : "-50px", "!important;top:50%;transform:translateY(-50%);@media (max-width: 600px){left:-15px!important;font-size:1.8rem;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0);
  var arrowsRight =
  /*#__PURE__*/

  /*#__PURE__*/
  (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("color:", (_props$colorArrow2 = props.colorArrow) !== null && _props$colorArrow2 !== void 0 ? _props$colorArrow2 : "var(--color-brand-blue-main)", "!important;font-size:clamp(1.5rem, 2.5vw, 2.6rem);padding:2px;position:absolute;z-index:500;right:", width === "xs" || width === "sm" ? "-25px" : "-50px", "!important;top:50%;transform:translateY(-50%);@media (max-width: 600px){right:-15px!important;font-size:1.8rem;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0);
  var settings = {
    dots: false,
    infinite: ((_props$children = props.children) === null || _props$children === void 0 ? void 0 : _props$children.length) > rows[width],
    speed: 500,
    slidesToShow: rows[width],
    slidesToScroll: 1,
    centerMode: false,
    nextArrow: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_mui_icons_material_ArrowForwardIosRounded__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      css: arrowsRight
    }),
    prevArrow: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_mui_icons_material_ArrowBackIosNewRounded__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      css: arrowsLeft
    }),
    responsive: [{
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: false
      }
    }, {
      breakpoint: 900,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: false
      }
    }, {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false
      }
    }]
  };
  var fakeElements = Array.from({
    length: (_props$numberOfPlaceh = props.numberOfPlaceholderItems) !== null && _props$numberOfPlaceh !== void 0 ? _props$numberOfPlaceh : 5
  }, function (v, i) {
    return i;
  });
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(CarruselContainer, {
    container: true,
    justifyContent: "center"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
    item: true,
    xs: 11,
    sm: 11,
    md: 11,
    lg: 10,
    xl: 10,
    my: "auto"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_slick_slider__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, settings, !(props !== null && props !== void 0 && props.children) && props.enablePlaceholder && fakeElements.map(function (e, i) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(props.placeholderItem, {
      key: i
    });
  }), (props === null || props === void 0 ? void 0 : props.children) && props.children)));
}

/* harmony default export */ __webpack_exports__["Z"] = (CustomCarrusel);
var CarruselContainer = (0,_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_templateObject || (_templateObject = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(["\n  position: relative;\n  margin: 5px 0px;\n  \n  & .slick-slider {\n  \n    position: relative;\n  }\n  \n  & .slick-arrow {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    z-index: 10;\n    \n    &:before {\n      display: none;\n    }\n  }\n  \n  & .slick-prev {\n    left: -40px;\n    \n    @media (max-width: 900px) {\n      left: -25px;\n    }\n    \n    @media (max-width: 600px) {\n      left: -10px;\n    }\n  }\n  \n  & .slick-next {\n    right: -40px;\n    \n    @media (max-width: 900px) {\n      right: -25px;\n    }\n    \n    @media (max-width: 600px) {\n      right: -10px;\n    }\n  }\n  \n  & .slick-list {\n    overflow: hidden;\n  }\n  \n  & .slick-track {\n    display: flex;\n    align-items: stretch;\n  }\n  \n  & .slick-slide {\n    > div {\n      height: 100%;\n    }\n  }\n"])));

/***/ }),

/***/ 68769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProfilePicture; }
/* harmony export */ });
/* harmony import */ var _emotion_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18872);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70917);



function ProfilePicture(_ref) {
  var src = _ref.src,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 50 : _ref$size;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(src),
      imgSrc = _useState[0],
      setImgSrc = _useState[1];

  var defaultImgSrc = "/icons/user_profile_icon1.svg";
  var profilePicture =
  /*#__PURE__*/

  /*#__PURE__*/
  (0,_emotion_css__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)("display:grid;grid-template-columns:minmax(0, ", size, "px);font-size:", size < 50 ? size / 3 : 12, "px;img{background-color:var(--color-brand-grey-secondary);padding:", src ? 0 : "1px", ";width:100%;object-fit:cover;aspect-ratio:1/1;border-radius:50%;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    setImgSrc(src);
  }, [src]);
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("div", {
    className: profilePicture
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("img", {
    onError: function onError() {
      return setImgSrc(defaultImgSrc);
    },
    src: imgSrc !== null && imgSrc !== void 0 ? imgSrc : defaultImgSrc,
    alt: "profile picture"
  }));
}

/***/ }),

/***/ 58254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86886);
/* harmony import */ var _mui_material_Skeleton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88078);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70917);





function PropertyCardCollectionSkeleton() {
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div", null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
    container: true,
    flexDirection: "column"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    variant: "rectangular",
    width: 300,
    height: 140,
    style: {
      borderRadius: 10
    }
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
    container: true,
    marginBottom: 1
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    width: "68%",
    height: 40
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    width: "80%",
    height: 20
  })), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    width: "50%",
    height: 30
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    width: "80%",
    height: 30
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    width: "80%",
    height: 30
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (PropertyCardCollectionSkeleton);

/***/ }),

/***/ 84256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);

 // Import css files





function SlickSlider(props) {
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react_slick__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, props);
}

/* harmony default export */ __webpack_exports__["Z"] = (SlickSlider);

/***/ }),

/***/ 42550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "av": function() { return /* binding */ setUser; },
/* harmony export */   "kS": function() { return /* binding */ logout; },
/* harmony export */   "o4": function() { return /* binding */ setToken; }
/* harmony export */ });
/* unused harmony exports authSlice, clearAuth */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66741);
/* harmony import */ var api_clients_clients_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62804);
/* harmony import */ var shared_services_auth_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84100);



var initialState = {
  token: (0,shared_services_auth_service__WEBPACK_IMPORTED_MODULE_1__/* .getUserToken */ .N)(),
  user: (0,shared_services_auth_service__WEBPACK_IMPORTED_MODULE_1__/* .userState */ .K)()
};
var authSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSlice */ .oM)({
  name: "auth",
  initialState: initialState,
  reducers: {
    setUser: function setUser(state, _ref) {
      var payload = _ref.payload;
      localStorage.setItem("user", JSON.stringify(payload));
      state.user = payload;
    },
    setToken: function setToken(state, _ref2) {
      var payload = _ref2.payload;
      localStorage.setItem("token", payload);
      state.token = payload;
    },
    clearAuth: function clearAuth(state) {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      state.user = null;
      state.token = null;
    }
  }
});
var _authSlice$actions = authSlice.actions,
    setUser = _authSlice$actions.setUser,
    setToken = _authSlice$actions.setToken,
    clearAuth = _authSlice$actions.clearAuth;

var logout = function logout() {
  return function (dispatch) {
    (0,api_clients_clients_request__WEBPACK_IMPORTED_MODULE_0__/* .userLogout */ .Kv)().then(function () {
      dispatch(clearAuth());
    });
  };
};
/* harmony default export */ __webpack_exports__["ZP"] = (authSlice.reducer);

/***/ }),

/***/ 63265:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/perfil",
      function () {
        return __webpack_require__(12948);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 36492:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useQuery; }
/* harmony export */ });
/* harmony import */ var _tanstack_query_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32161);
/* harmony import */ var _tanstack_query_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52924);
/* harmony import */ var _useBaseQuery_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67187);
'use client';



function useQuery(arg1, arg2, arg3) {
  const parsedOptions = (0,_tanstack_query_core__WEBPACK_IMPORTED_MODULE_0__/* .parseQueryArgs */ ._v)(arg1, arg2, arg3);
  return (0,_useBaseQuery_mjs__WEBPACK_IMPORTED_MODULE_1__/* .useBaseQuery */ .r)(parsedOptions, _tanstack_query_core__WEBPACK_IMPORTED_MODULE_2__/* .QueryObserver */ .z);
}


//# sourceMappingURL=useQuery.mjs.map


/***/ }),

/***/ 52587:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),

/***/ 28811:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

/***/ }),

/***/ 71383:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

/***/ }),

/***/ 90116:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(52587);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,arrayLikeToArray/* default */.Z)(arr);
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArray.js
var iterableToArray = __webpack_require__(28811);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(2937);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,iterableToArray/* default */.Z)(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || _nonIterableSpread();
}

/***/ }),

/***/ 2937:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52587);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2708,1629,8407,2615,6877,4022,70,3843,1664,7918,3828,4864,841,2834,6939,5675,6869,9027,8654,9470,4671,2888,179], function() { return __webpack_exec__(63265); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);